import { StyleSheet } from "react-native";
import colors from "../../styles/variables";

export default StyleSheet.create({
  container: {
    paddingTop: 16,
    paddingHorizontal: 20,
    backgroundColor: "white",
    borderBottomColor: colors.verylightgray,
    borderBottomWidth: 1,
  },
  activityIndicatorWrap: {
    width: "100%",
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  yourGoalContainer: {
    backgroundColor: colors.secondary,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 16,
  },
  yourGoalText: {
    color: "white",
    fontSize: 11,
    fontFamily: "Raleway_700Bold",
  },
  goalTitle: {
    flexWrap: "wrap",
    flexDirection: "row",
    alignItems: "center",
  },
  textInput_ios: {
    fontSize: 16,
    backgroundColor: "white",
    borderRadius: 33,
    color: colors.primary,
    paddingVertical: 12,
    fontFamily: "Raleway_400Regular",
    borderWidth: 1,
    borderColor: colors.lightgray,
  },
  textInput: {
    fontSize: 16,
    // backgroundColor: "white",
    // borderRadius: 33,
    color: colors.primary,
    // paddingVertical: 10,
    fontFamily: "Raleway_400Regular",
    // borderWidth: 1,
    // borderColor: colors.lightgray,
  },
  simulateTextInput: {
    position: "absolute",
    textAlign: "center",
    bottom: "45%",
    left: 0,
    right: 0,
    fontSize: 12,
    color: colors.primary,
    fontFamily: "Raleway_700Bold",
  },
  goalItemText: {
    color: colors.primary,
    fontSize: 12,
    fontFamily: "Raleway_700Bold",
    textAlign: "center",
  },
  iconContainer: {
    backgroundColor: colors.secondary,
    padding: 15,
    marginLeft: 10,
    borderRadius: 33,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
  },
  majText: {
    marginTop: 10,
    marginBottom: 6,
    marginLeft: "auto",
    fontSize: 12,
    color: colors.lightgray,
  },
  majTextLead: {
    marginTop: 10,
    marginBottom: 6,
    textAlign: "center",
    fontSize: 12,
    fontFamily: "Raleway_700Bold",
    color: colors.primary,
  },
});
